import { render } from "./CreatePart.vue?vue&type=template&id=73037b2e&scoped=true"
import script from "./CreatePart.vue?vue&type=script&lang=js"
export * from "./CreatePart.vue?vue&type=script&lang=js"

import "./CreatePart.vue?vue&type=style&index=0&id=73037b2e&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73037b2e"]])

export default __exports__